import React, { useEffect, useState } from "react";
import { Link, useRouteMatch } from "react-router-dom";
import MyOpinionLogo from "../../assets/images/MyOpinion_Logo_Head.png";
import { extractResponseValidationErrors, truncate } from "../../utils";
import { getUserFullName } from "../../utils/index";
import httpService from "../../services/http.service";
import { useFormik } from "formik";
import { Form, FormGroup } from "reactstrap";
import * as Yup from 'yup';
import AppAlert from "./AppAlert";
import AppDatepicker from "./AppDatePicker";
import useAlert from "../../hooks/useAlert";

const AppComment = ({ user, comment: data, toggleMute = () => null, onRefresh = () => null, shouldTruncate = true, truncateLength = 200, ...props }) => {

    const initialValues = {
        user_unmute_at: ''
    }

    const [fetching, setFetching] = useState(true);
    const [modal, setModal] = useState({
        mute: false,
        block: false,
        subscription: false,
    });
    const [alert, setAlert, onClose] = useAlert();
    const [submitting, setSubmission] = useState(false);

    const [comment, setComment] = useState(data);

    const routeMatch = useRouteMatch();

    const handleMuteCommentToggle = async (comment) => {
        if (!window.confirm('Confirmer ?')) return;

        try {
            await httpService.put(`/comments/${comment.com_id}/toggleMute`);
            setComment(comment => ({
                ...comment,
                com_mute: !comment.com_mute
            }));
        } catch (e) {
            throw e;
        }

    }


    const toggleMuteUser = async () => {

        if (!user?.user_muted) {
            setModal(state => ({
                ...state,
                mute: true
            }));
        } else {
            if (!window.confirm('Êtes-vous sûr de vouloir rendre cet utilisateur à nouveau visible ?')) return;

            const { data: response } = await httpService.put(`/users/${user.user_username}/toggleMute`);
            onRefresh()
        }
    }


    const onSubmit = async (values) => {
        try {

            setSubmission(true);
            setAlert(null);

            try {
                const { data: response } = await httpService.put(`/users/${user.user_username}/toggleMute`, values);
                onRefresh()
                onCancel();
            } catch ({ response }) {

                const { data, status } = response;

                if (response && status === 422) {
                    setAlert({
                        type: 'danger',
                        message: extractResponseValidationErrors(data)[0]
                    })
                }
                else if (response && status === 500) {
                    setAlert({
                        type: 'danger',
                        message: 'Erreur de traitement, veuillez contacter les administrateurs'
                    })
                }

            }
            finally {
                setSubmission(false);
            }

        } catch (error) {
            console.error(error);
        }
    }

    const formik = useFormik({
        initialValues,
        validationSchema: Yup.object().shape({
            user_unmute_at: Yup.string().ensure().required('Champ obligatoire')
        }),
        onSubmit
    });

    const onCancel = () => {
        formik.resetForm(initialValues);
        setModal(state => ({
            ...state,
            mute: false,
        }));
    }

    return (
        <div className="card mb-1">
            <div className="body">
                <div className="bs-example" data-example-id="media-alignment">
                    <div className="media" key={comment.com_id}>
                        <div className="media-left">
                            <Link to={`/users/${user.user_username}`}>
                                <img alt="" className="media-object rounded" src={user?.profile?.prof_picture || MyOpinionLogo} width="64" height="64" />
                            </Link>
                        </div>
                        <div className="media-body">
                            <h4 className="media-heading">
                                {getUserFullName(user, true)}{' '}{comment.com_type === 's' && <span className="badge badge-primary">Suggestion</span>}
                                <small className="float-right text-muted">{comment.com_date_created}</small>
                                {comment?.com_deleted_at && (
                                    <>
                                        <span className="float-right badge badge-danger" style={{ cursor: "pointer" }}>
                                            <span>Commentaire supprimé</span>{' '}
                                            <i className="fa fa-ban"></i>
                                        </span>
                                    </>
                                )}
                            </h4>
                            <p>{comment.com_text
                                ? (shouldTruncate ? truncate(comment.com_text, truncateLength) : comment.com_text)
                                : '-'}</p>
                            <nav className="d-flex text-muted font-weight-bold">
                                <span className="icon mr-3" style={{ cursor: "pointer" }} title="Identifiant">
                                    #{comment.com_id}
                                </span>
                                <span className="icon mr-3" title="Reponses" style={{ cursor: "pointer" }}>
                                    <i className="fa fa-reply"></i>{' '}{comment.comments_count || 0}
                                </span>
                                <span className="icon mr-3" title="Soutiens" style={{ cursor: "pointer" }}>
                                    <i className="fa fa-heart"></i>{' '}{comment.soutiens_count || 0}
                                </span>
                                <span className="icon mr-3 text-warning" title="Signalement" style={{ cursor: "pointer" }}>
                                    <i className="fa fa-warning"></i>{' '}{comment.reports_count || 0}
                                </span>
                                {comment.com_mute ? (<span className="icon mr-3 text-success" onClick={() => handleMuteCommentToggle(comment)} style={{ cursor: 'pointer' }}>
                                    <i className="fa fa-volume-up"></i>{' '}Unmute commentaire
                                </span>) : (<span className="icon mr-2 text-danger" onClick={() => handleMuteCommentToggle(comment)} style={{ cursor: 'pointer' }}>
                                    <i className="fa fa-volume-off"></i>{' '}Mute commentaire
                                </span>)}
                                {user?.user_muted ? (
                                    <span className="icon mr-3 text-success" onClick={toggleMuteUser} style={{ cursor: 'pointer' }}>
                                        <i className="fa fa-volume-up"></i>{' '}Unmute utilisateur
                                    </span>
                                ) : (
                                    <span className="icon mr-3 text-danger" onClick={toggleMuteUser} style={{ cursor: 'pointer' }}>
                                        <i className="fa fa-volume-off"></i>{' '}Mute utilisateur
                                    </span>
                                )}


                                {routeMatch.url !== `/opinions/${comment.com_sond}` && (<Link className="text-muted ml-auto" to={`/opinions/${comment.com_sond}`}>
                                    <i className="fa fa-eye"></i>{' '}Voir l'opinion
                                </Link>)}
                            </nav>
                        </div>
                    </div>
                </div>
            </div>



            <div className={`modal fade ${modal.mute ? 'd-block show' : ''}`} id="exampleModal" onClick={() => null}>
                <div className="modal-dialog modal-md" role="document">
                    <Form onSubmit={formik.handleSubmit}>
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title" id="exampleModalLabel">Mute utilisateur</h5>
                                <button type="button" className="close" data-dismiss="modal" aria-label="Close" onClick={onCancel}>
                                    <span aria-hidden="true">×</span>
                                </button>
                            </div>
                            <div className="modal-body">
                                {alert && <AppAlert onClose={onClose} type={alert.type}>{alert.message}</AppAlert>}
                                <AppDatepicker
                                    label="Invisible jusqu'au ?"
                                    className="form-control"
                                    error={formik.errors.user_unmute_at}
                                    touched={formik.touched.user_unmute_at}
                                    value={formik.values.user_unmute_at}
                                    onChange={(date) => formik.setFieldValue('user_unmute_at', date)}
                                    required
                                />
                            </div>
                            <div className="modal-footer">
                                <button type="button" className={`btn btn-round btn-danger font-weight-bold`} disabled={submitting} data-dismiss="modal" onClick={onCancel}>
                                    <span className="fa fa-times"></span>{' '}Annuler
                                </button>
                                <button type="submit" className={`btn btn-round btn-success font-weight-bold`} disabled={submitting}>
                                    <span className="fa fa-save"></span>{' '}{submitting ? 'Encour...' : 'Enregistrer'}
                                </button>
                            </div>
                        </div>
                    </Form>
                </div>
            </div>
        </div>
    )
}

export default AppComment;